<template>
  <a-tooltip>
    <template v-if="hasFile" #title> Click aquí para subir un nuevo audio </template>

    <label class="picker" :class="getPickerClass">
      <div class="picker__container" @dragover="handleDragOver" @drop="handleDrop">
        <div class="picker__content">
          <SmileOutlined v-if="hasFile" class="picker__icon" size="large" />
          <FolderOpenOutlined v-else class="picker__icon" :size="!filled ? 'large' : 'small'" />
          <span class="picker__text picker__text--title"> {{ pickerText }} </span>
          <span class="picker__text picker__text--small">{{ fileName }}</span>
        </div>
      </div>

      <input type="file" :accept="supportedTypes.join(',')" @change="handleFileChange" />
    </label>
  </a-tooltip>
</template>

<script>
import { defineComponent } from "vue";
import { SmileOutlined, FolderOpenOutlined } from "@ant-design/icons-vue";
export default defineComponent({
  components: {
    SmileOutlined,
    FolderOpenOutlined,
  },
  props: {
    value: {
      required: false,
      type: File,
      default: null,
    },
    storedFile: {
      required: false,
      type: String,
      default: "",
    },
    title: {
      required: false,
      type: String,
      default: "Arrastra tu archivo de audio",
    },
    widthFull: {
      required: false,
      type: Boolean,
      default: false,
    },
    filled: {
      required: false,
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      file: null,
      error: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.file = newValue || null;
      },
    },
  },
  computed: {
    hasFile() {
      return !!this.file || this.storedFile;
    },
    getPickerClass() {
      return {
        "picker--error": this.error,
        "picker--ready": this.hasFile,
        "picker--full": this.widthFull,
        "picker--filled": this.filled,
      };
    },
    getIconType() {
      return this.hasFile ? "smile" : "folder-open";
    },
    fileName() {
      const storeFileArray = this.storedFile?.split("/");
      const storedFileName = storeFileArray?.[storeFileArray.length - 1];

      const fileName = this.file?.name || storedFileName;

      return this.hasFile ? fileName : "Solo se aceptan archivos WAV, MP3, GSM";
    },
    pickerText() {
      if (this.error) return "Selecciona un archivo válido";
      return this.hasFile ? "Archivo listo" : this.title;
    },
    supportedTypes() {
      return ["audio/wav", "audio/mp3", "audio/x-gsm"];
    },
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];

      // Gets the number of channels of the audio file
      // let reader = new FileReader();

      // reader.onload = function (e) {
      //   const arrayBuffer = reader.result;

      //   const cx = new AudioContext();
      //   cx.decodeAudioData(arrayBuffer, (decoded) => {
      //     console.log({ AUDIO: decoded.numberOfChannels });
      //   });
      // };

      // reader.readAsArrayBuffer(file);

      this.handleFile(file);
    },
    handleFile(file) {
      if (!this.validateType(file)) return;
      this.setFile(file);
    },
    validateType(file) {
      if (!file) return false;
      // if (file.name.includes(".gsm")) {
      //   this.error = false;
      //   return true;
      // }
      // if (!this.supportedTypes.includes(file.type)) {
      //   this.setFile(null);
      //   this.error = true;
      //   return false;
      // }
      this.error = false;
      return true;
    },
    setFile(file) {
      this.file = file;
      this.$emit("update:value", this.file);
    },
    handleDragOver(event) {
      event.preventDefault();
      event.stopPropagation();
    },
    handleDrop(event) {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      this.handleFile(file);
    },
  },
});
</script>

<style lang="sass" scoped>
.picker
  cursor: pointer
  user-select: none

  &__container
    width: 100%
    max-width: 360px
    margin: 0 auto

    height: 140px
    color: $gray-6
    font-size: 12px
    border-radius: 8px
    border: 1px dashed $gray-6
    position: relative

  &__content
    height: 100%
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center

  &__icon
    font-size: 36px
    margin-bottom: 8px

  &__text
    font-size: 14px

    &--small
      font-size: 12px
      margin-top: 4px

  &__close
    position: absolute
    font-size: 14px
    top: 12px
    right: 12px
    z-index: 10

  &--full
    .picker__container
      max-width: 100% !important

  &--filled
    .picker__container
      background-color: $gray-2
      color: $gray-8
    .picker__text--title
      font-weight: 500
  &--error &__container
    color: $red-6
    background-color: #feefef
    border: 1px dashed $red-6

  &--ready &__container
    color: #52c41a
    background-color: #f6ffed
    border: 1px dashed #52c41a


label input[type="file"]
  display: none
</style>
